export const twoLetterElems = [
    "NI",
    "SE",
    "AC",
    "AG",
    "AL",
    "AM",
    "AR",
    "AS",
    "AT",
    "AU",
    "BA",
    "BE",
    "BH",
    "BI",
    "BK",
    "BR",
    "CL",
    "CO",
    "CU",
    "DB",
    "DS",
    "DY",
    "ER",
    "ES",
    "EU",
    "FE",
    "FL",
    "GA",
    "GD",
    "GE",
    "LA",
    "LI",
    "LR",
    "LU",
    "LV",
    "MC",
    "MD",
    "MG",
    "MN",
    "MO",
    "MT",
    "NA",
    "RA",
    "RB",
    "RE",
    "RF",
    "RG",
    "RH",
    "RN",
    "RU",
    "SI",
    "TA",
    "TB",
    "TC",
    "TE",
    "TH",
    "TI",
    "TL",
    "TM",
    "TS",
    "XE",
    "YB",
    "ZN",
    "ZR",
    // Ones you will not use (because more likely to be single-letter elements)
    // "HE", "CA", "NE", "CE", "ND", "CD", "HF", "HG", "HO", "HS", "NH", "NB",
    // "OG", "OS", "PA", "PB", "PD", "PM", "PO", "PR", "PT", "PU", "CF", "CM",
    // "CN", "CR", "CS", "FM", "FR", "IN", "IR", "KR", "SB", "SC", "SE", "SG",
    // "SM", "SN", "SR",
];
